import { render, staticRenderFns } from "./MallOrderListPage.vue?vue&type=template&id=3a643252&scoped=true"
import script from "./MallOrderListPage.vue?vue&type=script&lang=js"
export * from "./MallOrderListPage.vue?vue&type=script&lang=js"
import style0 from "./MallOrderListPage.vue?vue&type=style&index=0&id=3a643252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a643252",
  null
  
)

export default component.exports